interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps): JSX.Element {
  return (
    <svg viewBox="0 0 769 170" className={className} aria-label="Kore Auto" role="img">
      <path fillRule="evenodd" fill="currentColor" d="m0.03 150.55h769.1v19.61h-769.1z" />
      <path fillRule="evenodd" fill="currentColor" d="m0 0.33h769.15v19.49h-769.15z" />
      <path
        fill="currentColor"
        d="m250.85 95.1l-0.11 42.11-20.12-0.27-0.06-61.39 37.04-0.12c4.22-0.01 7.95-1.39 11.08-4.1 3.81-4.73 3.79-12.19-0.91-16.35-2.48-2.2-6.12-3.31-9.5-3.33l-37.6-0.16 0.12-19.12 38.17 0.08c15.59 0.03 29.38 8 32.17 23.62 2.42 16.25-2.68 30.08-18.73 35.51l20.86 45.18-21.88 0.45-19.24-42.1-11.29-0.02z"
      />
      <path
        fill="currentColor"
        d="m90.23 85.6l31.51 36.82 10.54 12.72c0.42 0.59 0.46 1.18 0.23 1.46-0.29 0.37-1.04 0.68-1.69 0.67l-23.34-0.23-31.09-37.78-28.31 31.47 0.02-98.18 20.1 0.02 0.2 47.93 39.89-48.05 23.78 0.04c0.31 1.41-0.1 2.49-1.19 3.5l-40.65 49.59z"
      />
      <path
        fill="currentColor"
        d="m467.11 51.55l20.3-0.18 0.04 49.79c0 4.99 2.4 9.11 6.37 12.12 7.21 5.46 17.31 5.71 25.31 1.23 4.15-2.32 7.29-6.73 7.31-11.76l0.23-70.22 19.92 0.07-0.1 71.26c-0.02 13.54-8.09 24.83-20.68 29.69-12.15 4.69-26.19 4.49-38.16-0.48-12.61-5.23-20.05-16.41-20.57-29.88l0.02-51.64z"
      />
      <path
        fill="currentColor"
        d="m448.49 137.26l-21.21-58.63-20.58 58.59-20.98-0.3 40.44-104.29c2.01-0.67 3.16 0.57 3.41 2.59l39.04 99.85c0.26 0.68-0.03 2.06-0.5 2.06z"
      />
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="m600.68 136.79l-20.16 0.32-0.09-86.46-24.97-0.09-0.08-18.09 70.26-0.01 0.09 18.01-25.07 0.14 0.02 86.18z"
      />
      <path fillRule="evenodd" fill="currentColor" d="m2.41 74.7h32.25v19.88h-32.25z" />
      <path fillRule="evenodd" fill="#d40025" d="m313.94 137.33l0.03-19.21 63.21 0.1-0.03 19.21z" />
      <path fillRule="evenodd" fill="#d40025" d="m313.94 32.08h63v19.01h-63z" />
      <path fillRule="evenodd" fill="#d40025" d="m313.94 75.11h26v19.24h-26z" />
      <path fillRule="evenodd" fill="#d40025" d="m351.12 75.1h25.98v19.25h-25.98z" />
      <path fillRule="evenodd" fill="currentColor" d="m733.1 74.68h32.12v19.86h-32.12z" />
      <path
        fill="currentColor"
        d="m671.01 38.12c-27.26 0-49.36 22.1-49.36 49.36 0 27.26 22.1 49.36 49.36 49.36 27.26 0 49.36-22.1 49.36-49.36 0-27.26-22.1-49.36-49.36-49.36zm0.01 79.68c-16.75 0-30.33-13.58-30.33-30.33 0-16.75 13.58-30.33 30.33-30.33 16.75 0 30.33 13.58 30.33 30.33 0 16.75-13.58 30.33-30.33 30.33z"
      />
      <path
        fill="currentColor"
        d="m173.06 38.17c-27.24 0-49.31 22.08-49.31 49.31 0 27.23 22.08 49.31 49.31 49.31 27.23 0 49.31-22.08 49.31-49.31 0-27.23-22.08-49.31-49.31-49.31zm18.38 73.8c-12.55 9.37-31.5 7.52-41.47-4.8-9.39-11.6-8.72-29.75 1.13-40.73 8.01-8.92 20.84-11.3 31.94-7.9 11.93 3.66 18.9 14.73 19.41 26.96 0.42 10.1-2.32 19.98-11.01 26.47z"
      />
    </svg>
  );
}
